module.exports = __webpack_public_path__ + "static/media/unauthorized.28faf3b6.svg";